<template>
  <div class="m-b-10">
    <div class="form-item tx-c m-b-10">{{ title }}</div>
    <el-table
      :data="childValue"
      class="m-b-10"
      style="width: 100%;">
      <el-table-column
        :label="item.default.title"
        v-for="item in inputList">
        <template scope="scope">
          <div class="p-t-10 p-b-20">
            <el-form-item
              style="margin-bottom: 0"
              label-width="0"
              :prop="getFieldName(scope.$index, item.default.name)"
              :rules="childRules[item.default.name]">
              <honray-input
                v-model="childValue[scope.$index][item.default.name]"
                :name="item.default.name"
                :type="item.input.write_type"
                :minLength="item.input.write_min"
                :maxLength="item.input.write_max"
                :disabled="disabled"
                @input="change"
                :rules="childRules"
                :isNeed="item.default.is_needed === 1"
                v-if="item.default.type == TYPE_INPUTTEXT">
              </honray-input>
              <honray-password
                v-model="childValue[scope.$index][item.default.name]"
                :name="item.default.name"
                :encryptType="item.password.encrypt_type"
                :encryptSplit="item.password.encrypt_split"
                :minLength="item.password.write_min"
                :maxLength="item.password.write_max"
                :disabled="disabled"
                @input="change"
                :isNeed="item.default.is_needed === 1"
                :rules="childRules"
                v-if="item.default.type == TYPE_PASSWORD">
              </honray-password>
              <honray-textarea
                v-model="childValue[scope.$index][item.default.name]"
                :name="item.default.name"
                :minLength="item.textarea.write_min"
                :maxLength="item.textarea.write_max"
                :disabled="disabled"
                @input="change"
                :isNeed="item.default.is_needed === 1"
                :rules="childRules"
                v-if="item.default.type == TYPE_TEXTAREA">
              </honray-textarea>
              <honray-radio
                v-model="childValue[scope.$index][item.default.name]"
                :name="item.default.name"
                :options="item.radio_option"
                :disabled="disabled"
                @input="change"
                :rules="childRules"
                v-if="item.default.type == TYPE_RADIO">
              </honray-radio>
              <honray-checkbox
                v-model="childValue[scope.$index][item.default.name]"
                :name="item.default.name"
                :selectMin="item.checkbox.select_min"
                :selectMax="item.checkbox.select_max"
                :options="item.checkbox_option"
                :disabled="disabled"
                @input="change"
                :isNeed="item.default.is_needed === 1"
                :rules="childRules"
                v-if="item.default.type == TYPE_CHECKBOX">
              </honray-checkbox>
              <honray-select
                v-model="childValue[scope.$index][item.default.name]"
                :name="item.default.name"
                :options="item.select_option"
                :disabled="disabled"
                @input="change"
                :rules="childRules"
                v-if="item.default.type == TYPE_SELECT">
              </honray-select>
              <honray-struct
                v-model="childValue[scope.$index][item.default.name]"
                :selectType="item.struct.select_type"
                :name="item.default.name"
                :options="item.struct_option"
                :disabled="disabled"
                @input="change"
                :rules="childRules"
                v-if="item.default.type == TYPE_STRUCT">
              </honray-struct>
              <honray-people
                v-model="childValue[scope.$index][item.default.name]"
                :selectType="item.people.select_type"
                :options="item.people_option"
                :disabled="disabled"
                @input="change"
                :rules="childRules"
                v-if="item.default.type == TYPE_PERSON">
              </honray-people>
              <honray-date
                v-model="childValue[scope.$index][item.default.name]"
                :name="item.default.name"
                :type="item.date.type"
                :config="item.date"
                :isRange="item.date.range_status == 1"
                placeholder="选择时间"
                :disabled="disabled"
                @input="change"
                :rules="childRules"
                v-if="item.default.type == TYPE_DATE">
              </honray-date>
              <honray-time
                v-model="childValue[scope.$index][item.default.name]"
                :name="item.default.name"
                :type="item.time.select_type"
                :config="item.time"
                :isRange="item.time.range_status == 1"
                placeholder="选择日期"
                :disabled="disabled"
                @input="change"
                :rules="childRules"
                v-if="item.default.type == TYPE_TIME">
              </honray-time>
              <honray-datetime
                v-model="childValue[scope.$index][item.default.name]"
                :name="item.default.name"
                :config="item.datetime"
                :isRange="item.datetime.range_status == 1"
                placeholder="选择日期时间"
                :disabled="disabled"
                @input="change"
                :rules="childRules"
                v-if="item.default.type == TYPE_BOTH_DATE_TIME">
              </honray-datetime>
              <honray-upload 
                v-model="childValue[scope.$index][item.default.name]"
                :title="item.default.title"
                :name="item.default.name"
                :config="item.file"
                :uploadUrl="host + 'form/upload/' + item.default.field_id"
                :disabled="disabled"
                @input="change"
                :rules="childRules"
                v-if="item.default.type == TYPE_FILE">
              </honray-upload>
              <honray-editor
                v-model="childValue[scope.$index][item.default.name]"
                :ref="item.default.name"
                :id="item.default.name"
                :col="item.default.layout"
                :width="650"
                :height="200"
                :uploadImgUrl="host + 'admin/upload'"
                :codeDefaultLang="item.editor.pc_code_type"
                :mapKey="item.editor.pc_map_key"
                :fileMaxSize="item.editor.pc_file_max"
                :fileUnit="getUnitText(item.editor.pc_file_unit)"
                :usePlupload="true"
                @input="change"
                :rules="childRules"
                v-if="item.default.type == TYPE_EDITOR && item.default.field_auth != 10">
              </honray-editor>
              <div
                v-html="childValue[scope.$index][item.default.name]"
                @input="change"
                :rules="childRules"
                v-if="item.default.type == TYPE_EDITOR && (hasEditAuth(item))">
              </div>
              <honray-cascader
                v-model="childValue[scope.$index][item.default.name]"
                :id="item.default.field_id"
                :disabled="disabled"
                :type="item.link.type"
                :filterable="item.link.has_search == 1"
                :areaLimit="item.link.area_limit == 1"
                :areaConfig="item.link.area_config"
                :showAllLevels="item.link.result_show == CASCADER_SHOW_FULL"
                @input="change"
                :rules="childRules"
                v-if="item.default.type == TYPE_CASCADER">
              </honray-cascader>
              <honray-foreignkey
                v-model="childValue[scope.$index][item.default.name]"
                :disabled="disabled"
                :id="item.default.field_id"
                :name="item.default.name"
                :filterable="item.key.has_search == 1"
                :isLink="item.key.is_link == 1"
                :linkField="item.key.link_pid"
                :efficientOptions="item.allOptions"
                :majorField="item.default.key_major"
                :depentField="item.default.key_depent"
                :type="item.key.type"
                :keyItem="item"
                :keyFilter="item.default.key_filter"
                :keyCascade="item.default.key_cascade"
                :keyFillin="item.default.key_fillin"
                :extraFieldList="extraFieldList"
                :hasNull="item.key.has_null == 1"
                @input="change"
                v-if="item.default.type == TYPE_FOREIGNKEY">
              </honray-foreignkey>
              <honray-user
                v-model="childValue[scope.$index][item.default.name]"
                :rules="childRules"
                v-if="item.default.type == TYPE_USER"
                :user="item.user_info">
              </honray-user>
              <honray-dealtime
                v-model="childValue[scope.$index][item.default.name]"
                :unit="item.deal_time.unit"
                :rules="childRules"
                v-if="item.default.type == TYPE_DEALTIME">
              </honray-dealtime>
              <honray-relate
                v-model="childValue[scope.$index][item.default.name]"
                :id="item.default.field_id"
                :name="item.default.name"
                :config="item.multi_link"
                :rules="childRules"
                :api="'multi_link'"
                :is-need="item.default.is_needed"
                v-if="item.default.type == TYPE_MULTIRELATE">
              </honray-relate>
              <honray-upload-img
                v-model="childValue[scope.$index][item.default.name]"
                :id="item.default.field_id"
                :config="item.image"
                :uploadUrl="host + 'form/upload/' + item.default.field_id"
                v-if="item.default.type == TYPE_PHOTO">  
              </honray-upload-img>
              <honray-relate
                v-model="childValue[scope.$index][item.default.name]"
                :id="item.default.field_id"
                :name="item.default.name"
                :config="item.child"
                :rules="childRules"
                :api="'child'"
                :is-need="item.default.is_needed"
                v-if="item.default.type == TYPE_SUBRELATE">
              </honray-relate>
            </el-form-item>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100px" v-if="!disabled">
        <template scope="scope">
          <el-button size="small" type="danger" @click="deleteRow(scope.$index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="tx-c m-t-10" v-if="!disabled">
      <el-button type="primary" @click="addRow">添加一行</el-button>
    </div>
  </div>
</template>

<style scope>
  .form-item {
    font-size: 14px;
    color: #48576a;
  }
</style>

<script>
  /**
   * @param Number value 绑定值
   * @param Array inputList 子表单控件
   * @param Array rules 表单验证规则
   * @param String name 控件名
   * @param String title 子表单标题
   * @param Number dataLimit 数据限制
   * @param Boolean disabled 是否禁用
   */
  import modelConfig from '../../../../config/modelConfig'
  import honrayInput from './honrayInput.vue'
  import honrayPassword from './honrayPassword.vue'
  import honrayTextarea from './honrayTextarea.vue'
  import honrayRadio from './honrayRadio.vue'
  import honrayCheckbox from './honrayCheckbox.vue'
  import honraySelect from './honraySelect.vue'
  import honrayStruct from './honrayStruct.vue'
  import honrayPeople from './honrayPeople.vue'
  import honrayDate from './honrayDate.vue'
  import honrayTime from './honrayTime.vue'
  import honrayDatetime from './honrayDatetime.vue'
  import honrayUpload from './honrayUpload.vue'
  import honrayEditor from './honrayEditor.vue'
  import honrayCascader from './honrayCascader.vue'
  import honrayUploadImg from './honrayUploadImg.vue'
  import honrayRelate from './honrayRelate.vue'
  export default {
    props: ['value', 'inputList', 'rules', 'name', 'title', 'dataLimit', 'disabled', 'form'],
    data() {
      return {
        childValue: null,
        model: {},
        host: '',
        editors: [],
        childRules: {}
      }
    },
    methods: {
      hasEditAuth(item) {
        return item.default.field_auth == 10
      },
      getFieldName(index, name) {
        return `${this.name}.${index}.${name}`
      },
      initData(inputList) {
        this.model = {}
        let childRules = {}
        this.inputList.forEach((item) => {
          let name = item.default.name // 字段名
          let title = item.default.title // 字段标题
          let isNeeded = item.default.is_needed // 是否必填
          let type = item.default.type // 控件类型
          childRules[name] = []
          if (isNeeded) {
            childRules[name].push({ required: true, message: `请输入${title}` })
          }
          if (type == this.TYPE_CHECKBOX) {
            // 复选框
            if (!this.model[name]) {
              this.model[name] = []
            }
          } else if (type == this.TYPE_EDITOR) {
            // 富文本编辑器
            this.editors.push(name)
          } else if (type == this.TYPE_CASCADER) {
            // 级联选择器
            if (!this.model[name]) {
              this.model[name] = []
            }
          } else if (type == this.TYPE_STRUCT) {
            if (item.struct.select_type == 10) {
              this.model[name] = ''
            } else {
              this.model[name] = []
            }
          } else if (type == this.TYPE_PERSON) {
            if (item.people.select_type == 10) {
              this.model[name] = ''
            } else {
              this.model[name] = []
            }
          } else {
            this.model[name] = ''
          }
        })
        this.childRules = childRules
        console.log('childRules', this.childRules)
        if (!this.childValue.length) {
          this.addRow()
        }
        console.log('childValue = ', this.childValue)
        console.log('inputList = ', this.inputList)
      },
      addRow() {
        if (this.dataLimit && this.childValue.length == this.dataLimit) {
          _g.toastMsg(this, 'error', `数据上限为${this.dataLimit}条`)
          return
        }
        this.childValue.push(_.cloneDeep(this.model))
        this.change()
      },
      deleteRow(index) {
        this.childValue.splice(index, 1)
        this.change()
      },
      change() {
        this.$emit('input', this.childValue)
      },
      getUnitText(unit) {
        let outputUnit = 'KB'
        switch (unit) {
          case 10:
            outputUnit = 'KB'
            break
          case 20:
            outputUnit = 'MB'
            break
        }
        return outputUnit
      }
    },
    created() {
      this.host = HOST
      if (this.value && this.value.length) {
        this.childValue = this.value
      } else {
        this.childValue = []
      }
      this.initData(this.inputList)
    },
    components: {
      honrayInput,
      honrayPassword,
      honrayTextarea,
      honrayRadio,
      honraySelect,
      honrayStruct,
      honrayPeople,
      honrayDate,
      honrayTime,
      honrayDatetime,
      honrayCheckbox,
      honrayUpload,
      honrayRelate,
      honrayEditor,
      honrayCascader,
      honrayUploadImg
    },
    mixins: [modelConfig]
  }
</script>


// WEBPACK FOOTER //
// honraySubform.vue?b3b5f94c